import React, { Fragment } from 'react';
import NavbarContainer from 'shared/containers/NavbarContainer';
import AboutContainer from 'bundles/About/containers/AboutContainer';

const AboutScene = (props) => {
    return (
        <Fragment>
            <NavbarContainer />
            <AboutContainer {...props} />
        </Fragment>
    );
};

export default AboutScene;
